/**
 * Подпись под заголовком карточки точки сноса — «чем именно является эта точка».
 *
 * У одного трека три маркера, и координаты у них разные: место регистрации,
 * положение сегодня, положение на выбранный день. Пока подпись у всех троих
 * бралась от ползунка, карточка над отметкой вылова недельной давности честно
 * показывала её координаты и врала про дату: «положение на 12 августа»
 * (бой 2026-08-12).
 *
 * Отдельный модуль, а не строка внутри JSX: в витрине тестируются чистые
 * функции (компонентных тестов нет), а врала здесь именно логика выбора текста.
 */
import { msg, type Msg } from '../i18n'
import { humanDate } from './driftDay'
import { pointDate } from './driftDay'

export interface TrackPointFlags {
  /** Донный вид: течением не сносится (статус 'static'). */
  static?: boolean
  /** Позиции на выбранный день нет — показана последняя известная. */
  frozen?: boolean
}

export function trackPointCaption(
  props: { role?: string; observed_date?: string },
  selected: string,
  today: string,
  flags: TrackPointFlags,
): Msg {
  if (flags.static) return msg('models.trackPoint.static')

  // Отметка проверяется ДО frozen: замерзает дневной маркер, а отметка — факт
  // регистрации, ей замерзать нечем (см. sliceDriftCollection).
  if (props.role === 'origin' && props.observed_date) {
    return msg('models.trackPoint.origin', { date: humanDate(props.observed_date) })
  }

  if (flags.frozen) return msg('models.trackPoint.frozen')

  return msg('models.trackPoint.onDay', {
    date: humanDate(pointDate(props, selected, today)),
  })
}
